import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TraumatologoRoquetasDeMar() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 text-white py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <nav className="text-sm mb-6">
            <ol className="flex items-center space-x-2 text-teal-100">
              <li><a href="/" className="hover:text-white transition-colors cursor-pointer">Inicio</a></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li><a href="/zonas-servicio" className="hover:text-white transition-colors cursor-pointer">Zonas de Servicio</a></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-white font-semibold">Roquetas de Mar</li>
            </ol>
          </nav>

          <div className="max-w-4xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Traumatólogo Veterinario</strong> en Roquetas de Mar
            </h1>
            <p className="text-xl md:text-2xl text-teal-50 mb-8 leading-relaxed">
              Cirugía especializada en <strong>TPLO, fracturas y traumatología veterinaria</strong> en Roquetas de Mar, Almería. Servicio móvil en tu clínica con más de 25 años de experiencia.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/#contacto"
                className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                <span>Solicitar Valoración en Roquetas</span>
              </a>
              <a
                href="tel:+34600581975"
                className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>Llamar: 600 581 975</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                <strong>Especialista en Traumatología Veterinaria</strong> en Roquetas de Mar
              </h2>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Como <strong>traumatólogo veterinario especializado en Roquetas de Mar</strong>, ofrezco un servicio móvil completo de cirugía ortopédica avanzada directamente en tu clínica veterinaria de confianza.
              </p>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Con más de <strong>25 años de experiencia exclusiva en cirugía veterinaria</strong>, me especializo en procedimientos complejos como <strong>TPLO (Osteotomía de Nivelación de la Meseta Tibial)</strong>, reparación de fracturas, luxaciones y patologías ortopédicas en perros y gatos.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Mi servicio en <strong>Roquetas de Mar y Aguadulce</strong> incluye todo el equipamiento quirúrgico necesario, instrumental de última generación y materiales de osteosíntesis de máxima calidad.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/bd91b1edbabc346483f2dcb7cb543bf2.jpg"
                alt="Traumatólogo veterinario Roquetas de Mar realizando cirugía TPLO especializada en clínica veterinaria"
                title="Cirugía TPLO en Roquetas de Mar - Traumatología Veterinaria"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Servicios de Traumatología Veterinaria</strong> en Roquetas de Mar
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Cirugía ortopédica especializada con servicio móvil en tu clínica de Roquetas de Mar, Aguadulce y alrededores
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Cirugía TPLO Roquetas de Mar</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Técnica quirúrgica de referencia para rotura de ligamento cruzado craneal. Osteotomía de precisión con placas bloqueadas de última generación.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Planificación radiográfica digital</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Instrumental específico TPLO</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Recuperación funcional completa</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-bone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Reparación de Fracturas</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Osteosíntesis avanzada con placas, clavos intramedulares y fijadores externos para fracturas complejas en perros y gatos.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fracturas de fémur, tibia y húmero</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fracturas articulares complejas</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fijación mínimamente invasiva</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-wheelchair-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Luxaciones y Displasias</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Tratamiento quirúrgico de luxaciones de rótula, cadera y codo. Cirugías correctivas para displasia de cadera y codo.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Luxación de rótula grados III-IV</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Prótesis de cadera (FHO)</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Triple osteotomía pélvica</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-scissors-cut-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Artroscopias</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Cirugía mínimamente invasiva para diagnóstico y tratamiento de patologías articulares en hombro, codo y rodilla.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fragmentación proceso coronoides</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Osteocondritis disecante</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Lesiones meniscales</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-brain-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Neurocirugía Veterinaria</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Cirugía de columna vertebral para hernias discales, compresiones medulares y fracturas vertebrales.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Hemilaminectomía dorsal</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fenestración discal</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Estabilización vertebral</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-microscope-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Cirugía Oncológica</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Resección de tumores óseos y de tejidos blandos con márgenes oncológicos adecuados y cirugía reconstructiva.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Mastectomías radicales</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Resección de sarcomas</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Amputaciones oncológicas</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              ¿Por Qué Elegir un <strong>Traumatólogo Veterinario Especialista</strong> en Roquetas de Mar?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>Experiencia Exclusiva en Traumatología</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Más de <strong>25 años dedicados exclusivamente a la cirugía ortopédica veterinaria</strong>. Cientos de cirugías TPLO, fracturas y luxaciones realizadas con éxito en Roquetas de Mar y toda Almería.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>Servicio Móvil en Tu Clínica</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Me desplazo a tu <strong>clínica veterinaria en Roquetas de Mar</strong> con todo el equipamiento necesario. Tu paciente opera en un entorno conocido, reduciendo el estrés y mejorando la recuperación.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>Tecnología de Última Generación</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Instrumental quirúrgico específico para cada procedimiento, placas bloqueadas de titanio, sistemas de fijación avanzados y equipamiento de artroscopia.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>Disponibilidad y Rapidez</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Atención urgente en <strong>Roquetas de Mar y Aguadulce</strong>. En traumatología veterinaria, el tiempo es crucial para garantizar el mejor pronóstico y recuperación funcional.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coverage Area */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Cobertura en Roquetas de Mar</strong> y Alrededores
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Servicio de traumatología veterinaria en toda la zona de Roquetas de Mar
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-2-fill text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                <strong>Roquetas de Mar Centro</strong>
              </h3>
              <p className="text-gray-600 text-sm">
                Servicio completo de traumatología veterinaria en el centro de Roquetas
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-2-fill text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                <strong>Aguadulce</strong>
              </h3>
              <p className="text-gray-600 text-sm">
                Cirugía TPLO y traumatología en Aguadulce
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-2-fill text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                <strong>Urbanizaciones Costeras</strong>
              </h3>
              <p className="text-gray-600 text-sm">
                Cobertura en todas las urbanizaciones de Roquetas de Mar
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-teal-600 to-teal-800 rounded-2xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              ¿Tu Clínica Está en Roquetas de Mar?
            </h3>
            <p className="text-teal-50 mb-6 max-w-2xl mx-auto">
              Contacta conmigo para evaluar el caso, obtener una segunda opinión o programar la intervención quirúrgica en tu clínica veterinaria de Roquetas de Mar.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/#contacto"
                className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                <span>Solicitar Valoración Urgente (24h)</span>
              </a>
              <a
                href="tel:+34600581975"
                className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>Llamar: 600 581 975</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
